import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { OpportunityCard } from '~/components';
import { buildAPIUrl, isEmpty } from '~/utils';
import { apiClient } from '~/utils/apiClient';
import { OpportunityFilters, useFilters, } from '~/components/OpportunityFilters';
import OpportunityGrid from '~/components/OpportunityGrid/OpportunityGrid';
const SubcategoryPage = ({ preloadCount = 9, pageName, contentTypes, landingPageUrl, iconText, }) => {
    var _a, _b;
    const { searchParams, setSearchParams, searchQuery, setSearchQuery, searchItem, setSearchItem, country, setCountry, industry, setIndustry, } = useFilters();
    const [page, setPage] = useState(Number(searchParams.get('page')) || 1);
    const { data, isLoading, isPlaceholderData } = useQuery({
        queryKey: [contentTypes, page, country, industry, searchItem === null || searchItem === void 0 ? void 0 : searchItem.name],
        queryFn: async () => await apiClient(buildAPIUrl('/api/v1/mo', {
            contentTypes: contentTypes,
            page: page,
            country: country.value,
            industry: industry.value,
            q: searchItem === null || searchItem === void 0 ? void 0 : searchItem.name,
            size: preloadCount,
        })),
        placeholderData: keepPreviousData,
    });
    const onPageChange = (page) => {
        setSearchParams((prev) => {
            const params = new URLSearchParams(prev);
            params.set('page', page.toString());
            return params;
        });
        setPage(page);
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };
    const handleFilterChange = ({ industry, country, searchItem, }) => {
        setSearchItem(searchItem);
        setCountry(country);
        setIndustry(industry);
        setPage(1);
        setSearchParams((prev) => {
            const params = new URLSearchParams(prev);
            params.set('page', '1');
            return params;
        });
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "page-elements__actions container" }, { children: _jsx(OpportunityFilters, { contentTypes: contentTypes, onFilterChange: handleFilterChange, searchQuery: [searchQuery, setSearchQuery], setSearchItem: setSearchItem }) })), _jsx(OpportunityGrid, { data: data, isLoading: isLoading, isPlaceholderData: isPlaceholderData, preloadCount: preloadCount, iconText: iconText, page: page, onPageChange: onPageChange, heading: _jsxs(_Fragment, { children: [_jsx("h2", Object.assign({ className: "category__heading__title" }, { children: `${pageName} (${!data || isLoading || isPlaceholderData
                                ? 'Loading...'
                                : (_a = data === null || data === void 0 ? void 0 : data.totalCount) !== null && _a !== void 0 ? _a : ''}${isEmpty(searchItem === null || searchItem === void 0 ? void 0 : searchItem.name) &&
                                isEmpty(country.value) &&
                                isEmpty(industry.value)
                                ? ''
                                : ' Found'})` })), _jsx("a", Object.assign({ href: landingPageUrl, className: "category__heading__back-button" }, { children: "Back to frontpage \u00BB" }))] }), noResults: _jsxs(_Fragment, { children: [_jsx("h3", Object.assign({ className: "heading--no-transform" }, { children: "We didn't find match for your search." })), _jsx("h3", Object.assign({ className: "heading--no-transform" }, { children: "Here are some of our latest in Act Now category." })), _jsx("div", Object.assign({ className: "category__results" }, { children: (_b = data === null || data === void 0 ? void 0 : data.latest) === null || _b === void 0 ? void 0 : _b.map((item, key) => (_jsx(OpportunityCard, { opportunity: item, iconText: iconText }, `Page${page}/LatestOpportunity${key}`))) }))] }) })] }));
};
export default SubcategoryPage;
